import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const FacilityContext = createContext(null);

export function FacilityProvider({ children }) {
  const { user } = useAuth();
  const [facilities, setFacilities] = useState([]);
  const [facilityId, setFacilityId] = useState(null);

  const refresh = useCallback(async () => {
    if (!user || user === false) return;
    try {
      const { data } = await api.get("/facilities");
      setFacilities(data);
      if (!facilityId || !data.find((f) => f.id === facilityId)) {
        const stored = localStorage.getItem("modesto_facility_id");
        const initial =
          (stored && data.find((f) => f.id === stored)?.id) ||
          user.default_facility_id ||
          (data[0] && data[0].id) ||
          null;
        if (initial) {
          setFacilityId(initial);
          localStorage.setItem("modesto_facility_id", initial);
        }
      }
    } catch { /* ignore */ }
  }, [user, facilityId]);

  useEffect(() => { refresh(); }, [refresh]);

  const setAndPersist = (id) => {
    setFacilityId(id);
    if (id) localStorage.setItem("modesto_facility_id", id);
  };

  return (
    <FacilityContext.Provider value={{ facilities, facilityId, setFacilityId: setAndPersist, refresh }}>
      {children}
    </FacilityContext.Provider>
  );
}

export const useFacility = () => useContext(FacilityContext);
